import styled, { CSSObject, DefaultTheme } from 'styled-components';
import { TypographyVariant } from '@mybet/components/theme/createTypography';

type MappedTypographyColors =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'textPrimary'
  | 'textSecondary'
  | 'textTertiary'
  | 'error'
  | 'warning'
  | 'link'
  | 'success';
export type TypographyProps = {
  color?: MappedTypographyColors | string;
  align?: 'center' | 'left' | 'right' | 'justify' | 'inherit';
  size?: number | string;
  lineHeight?: string;
  letterSpacing?: string;
  gutterTop?: number;
  gutterBottom?: number;
  variant?: TypographyVariant;
  uppercase?: boolean;
  fontWeight?: 300 | 400 | 500 | 700 | 900;
  as?: React.ElementType;
  style?: CSSObject;
};

function getTypographyColor(theme: DefaultTheme, color: string) {
  switch (color) {
    case 'textPrimary':
      return { color: theme.text.primary };
    case 'textSecondary':
      return { color: theme.text.secondary };
    case 'textTertiary':
      return { color: theme.text.secondary };
    case 'accent':
      return { color: theme.colors.accent.main };
    case 'error':
      return { color: theme.colors.error.main };
    case 'success':
      return { color: theme.colors.success.main };
    case 'warning':
      return { color: theme.colors.warning.main };
    case 'link':
      return {
        color: theme.colors.link.main,
        textDecoration: 'none',
        cursor: 'pointer',
        transition: `all ${theme.transitionEasing}`,
        '&:hover': {
          textDecoration: 'none',
          color: theme.colors.link.hover,
        },
        '&:active': {
          textDecoration: 'none',
          color: theme.colors.link.visited,
        },
        '@media (hover:none)': {
          textDecoration: 'none',
          color: theme.colors.link.main,
        },
      };
    default:
      // @ts-ignore
      return { color: theme[color] };
  }
}
const Typography = styled.span<TypographyProps>((props) => {
  const typographyStyles = props.variant
    ? props.theme.typography[props.variant]
    : props.theme.typography.body1;

  return {
    ...typographyStyles,
    color: 'inherit',
    textAlign: props.align ?? 'inherit',
    ...((props.gutterTop || props.gutterTop === 0) && {
      marginTop: props.theme.spacing(props.gutterTop),
    }),
    ...((props.gutterBottom || props.gutterBottom === 0) && {
      marginBottom: props.theme.spacing(props.gutterBottom),
    }),
    ...(props.color && getTypographyColor(props.theme, props.color)),

    ...(props.lineHeight && { lineHeight: props.lineHeight }),
    ...(props.letterSpacing && { letterSpacing: props.letterSpacing }),
    ...(props.uppercase && { textTransform: 'uppercase' }),
    ...(props.fontWeight && { fontWeight: props.fontWeight }),
    ...(props.size && { fontSize: props.size }),
  };
});

export default Typography;
